<template>
  <SpecimenSurveyQueryTab :value="vegetativePlotDataSource" />
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import SpecimenSurveyQueryTab from '@/components/VegetativeMonitoring/PlotDetail/Tabs/SpecimenSurveyQueryTab'

  export default {
    components: {
      SpecimenSurveyQueryTab,
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData']),
      vegetativePlotDataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.vegetativeMonitoringEnvirodata)
        return data && data.plotData
      },
    },
  }
</script>